<template>
<div>
  <b-row class="justify-content-center">
    <h3>{{$ml.get('needatradcdn')}}</h3>
  </b-row>
  <b-row class="justify-content-center">
    <p><strong>Quanteec</strong> {{$ml.get('cdnagnostic')}}</p>
</b-row>
  <b-row class="justify-content-around align-items-center">
      <b-col lg="1" cols="3">
          <a href="https://bunny.net/solutions/video-delivery" target="_blank"><b-img fluid :src="require('@/assets/cdn/bunnynet-logo-dark.svg')"></b-img></a>
      </b-col>
      <b-col lg="1" cols="3">
          <a href="https://www.fastly.com/products/cdn" target="_blank"><b-img fluid :src="require('@/assets/cdn/fastly.svg')"></b-img></a>
      </b-col>
      <b-col lg="1" cols="3">
          <a href="https://www.cdn77.com/video-cdn" target="_blank"><b-img fluid :src="require('@/assets/cdn/cdn77.svg')"></b-img></a>
      </b-col>
      <b-col lg="1"  cols="3" style="max-height: 40px;">
          <a href="https://aws.amazon.com/fr/cloudfront/" target="_blank"><b-img fluid :src="require('@/assets/cdn/aws.svg')"></b-img></a>
      </b-col>
      <b-col lg="1" cols="3">
          <a href="https://www.akamai.com/fr/solutions/content-delivery-network/media-delivery" target="_blank"><b-img fluid :src="require('@/assets/cdn/akamai.svg')"></b-img></a>
      </b-col>
      <b-col lg="1" cols="3">
          <a href="https://www.cloudflare.com/fr-fr/products/cloudflare-stream/" target="_blank"><b-img fluid :src="require('@/assets/cdn/cloudflare-logo.svg')"></b-img></a>
      </b-col>
  </b-row>
  <!-- Mettre des exemples et des liens -->
  <b-row class="justify-content-center marginal">
    <h5>{{$ml.get('wecanmanage')}}</h5>
  </b-row>
</div>
</template>

<script>
import CDNService from '@/services/cdn.service.js'
let cdnService = new CDNService();
export default {
  name: "CDNDoc",
  data: function () {
    return {
    };
  },
  mounted: function () {
  },
  methods: {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


</style>
